export default [
    {
        path: '/seckill/list',
        name: '限时秒杀',
        component: () => import('@/views/activity/SeckillList'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/discount/list',
        name: '限时优惠',
        component: () => import('@/views/activity/DiscountList'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/special/list',
        name: '今日特价',
        component: () => import('@/views/activity/SpecialList'),
        meta: { breadNumber: 1 }
    },
    {
        path: '/discount/detail/:id',
        name: '活动商品详情',
        component: () => import('@/views/activity/DiscountDetail'),
        meta: { breadNumber: 2 }
    },
    {
        path: '/special/detail/:id',
        name: '活动商品详情',
        component: () => import('@/views/activity/SpecialDetail'),
        meta: { breadNumber: 2 }
    },
    {
        path: '/seckill/detail/:id',
        name: '活动商品详情',
        component: () => import('@/views/activity/SeckillDetail'),
        meta: { breadNumber: 2 }
    }
];
